import { useEffect, useState } from 'react';
import { DataTable, Column } from '../../../shared/components';
import { getReportsRepository } from '../../../shared/services/reports/repositoryFactory';
import { UserKpiRow, ReportFilters } from '../../../shared/services/reports/types';
import { formatDuration } from '../../../shared/utils/datetime';
import { KpiPanelShell } from './KpiPanelShell';
import { KpiBarList } from './KpiBarList';

const repo = getReportsRepository();

export function UserKpiPanel({ filters }: { filters: ReportFilters }) {
  const [rows, setRows] = useState<UserKpiRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    repo.byUser(filters, 1, 200).then((res) => {
      setRows(res.items);
      setIsLoading(false);
    });
  }, [filters]);

  const columns: Column<UserKpiRow>[] = [
    { key: 'userName', header: 'Colaborador', render: (r) => r.userName, sortable: true, sortValue: (r) => r.userName },
    { key: 'totalSeconds', header: 'Tiempo total', render: (r) => formatDuration(r.totalSeconds), sortable: true, sortValue: (r) => r.totalSeconds },
    { key: 'recordsCount', header: 'Registros', render: (r) => r.recordsCount },
  ];

  return (
    <KpiPanelShell title="Ranking de tiempo por colaborador" subtitle="Tiempo total registrado por cada colaborador en el periodo filtrado">
      {!isLoading && (
        <div className="mb-4">
          <KpiBarList rows={rows.slice(0, 6).map((r) => ({ label: r.userName, value: r.totalSeconds, displayValue: formatDuration(r.totalSeconds) }))} />
        </div>
      )}
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.userId} isLoading={isLoading} emptyTitle="Sin datos" pageSize={5} />
    </KpiPanelShell>
  );
}
